var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowUpBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10347 5.36636C1.96062 5.51632 1.9664 5.75369 2.11636 5.89653C2.26632 6.03937 2.50369 6.0336 2.64653 5.88364L5.62378 2.758V10.125C5.62378 10.3321 5.79167 10.5 5.99878 10.5C6.20589 10.5 6.37378 10.3321 6.37378 10.125V2.75782L9.35119 5.88364C9.49404 6.0336 9.7314 6.03937 9.88137 5.89653C10.0313 5.75369 10.0371 5.51632 9.89426 5.36636L6.36091 1.65689C6.2804 1.57237 6.17769 1.52238 6.07092 1.50693C6.04757 1.50238 6.02346 1.5 5.99878 1.5C5.97393 1.5 5.94965 1.50242 5.92615 1.50703C5.81962 1.52259 5.71717 1.57254 5.63682 1.65689L2.10347 5.36636Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpBlue2);
export default __webpack_public_path__ + "static/media/icon-arrow-up-blue2.44165ea76c1448f31bbb57161eccbb52.svg";
export { ForwardRef as ReactComponent };